import FormValidations from "../FormValidations";
import {SimpleInputValidator} from "./SimpleInputValidator";

export class EmailInputValidator implements SimpleInputValidator {
    isValid(value: string, required: boolean): boolean {
        return required
            ? FormValidations.emailIsValid(value)
            : FormValidations.checkOptionalInput(value, FormValidations.emailIsValid);
    }
}